import { ArrowLeft, Edit } from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import { useNavigate } from "react-router-dom";

const PersonalInformation = () => {
  const navigate = useNavigate();
  const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");

  const personalInfo = [
    { label: "Full Name", value: userProfile.name || "Rajesh Shah" },
    { label: "Email", value: userProfile.email || "rajesh@gmail.com" },
    { label: "Gender", value: userProfile.gender || "Male" },
    {
      label: "Date of Birth",
      value: userProfile.dateOfBirth
        ? new Date(userProfile.dateOfBirth).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : "January 15, 1998",
    },
    { label: "Age", value: `${userProfile.age || "26"} years` },
    { label: "Height", value: `${userProfile.height || "170"} cm (5'9")` },
    { label: "Weight", value: `${userProfile.weight || "68"} kg` },
    { label: "Blood Type", value: userProfile.bloodType || "O+" },
    { label: "Race/Ethnicity", value: userProfile.ethnicity || "Asian" },
  ];

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="mx-auto max-w-md space-y-4 p-4">
        {/* Header */}
        <div className="flex items-center justify-between pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/profile")}
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-xl font-bold text-foreground">
            Personal Information
          </h1>
          <Button
            size="icon"
            variant="ghost"
            className="rounded-xl"
            onClick={() => navigate("/profile/edit")}
          >
            <Edit className="h-5 w-5" />
          </Button>
        </div>

        {/* Personal Information Card */}
        <Card className="rounded-2xl border-0 p-5 shadow-sm">
          <h3 className="mb-4 font-semibold text-foreground">
            Basic Information
          </h3>
          <div className="space-y-3">
            {personalInfo.map((info, index) => (
              <div key={index}>
                <div className="flex items-center justify-between py-2">
                  <span className="text-sm text-muted-foreground">
                    {info.label}
                  </span>
                  <span className="text-right font-medium text-foreground">
                    {info.value}
                  </span>
                </div>
                {index < personalInfo.length - 1 && (
                  <div className="h-px bg-border" />
                )}
              </div>
            ))}
          </div>
        </Card>

        {/* Medical Information */}
        <Card className="rounded-2xl border-0 p-5 shadow-sm">
          <h3 className="mb-4 font-semibold text-foreground">
            Medical Information
          </h3>
          <div className="space-y-3">
            {[
              { label: "Allergies", value: userProfile.allergies || "None" },
              {
                label: "Chronic Conditions",
                value: userProfile.chronicConditions || "None",
              },
              {
                label: "Current Medications",
                value: userProfile.medications || "Vitamin D, Omega-3",
              },
              {
                label: "Emergency Contact",
                value: userProfile.emergencyContact || "+91 98765 43210",
              },
            ].map((info, index) => (
              <div key={index}>
                <div className="flex items-center justify-between py-2">
                  <span className="text-sm text-muted-foreground">
                    {info.label}
                  </span>
                  <span className="max-w-[60%] text-right font-medium text-foreground">
                    {info.value}
                  </span>
                </div>
                {index < 3 && <div className="h-px bg-border" />}
              </div>
            ))}
          </div>
        </Card>

        {/* Fitness Goals */}
        <Card className="rounded-2xl border-0 p-5 shadow-sm">
          <h3 className="mb-4 font-semibold text-foreground">Fitness Goals</h3>
          <div className="space-y-3">
            {[
              {
                label: "Primary Goal",
                value: userProfile.goal || "Improve Health",
              },
              {
                label: "Target Weight",
                value: `${userProfile.targetWeight || "60"} kg`,
              },
              {
                label: "Activity Level",
                value: userProfile.activityLevel || "Moderate",
              },
              {
                label: "Weekly Exercise",
                value: `${userProfile.weeklyExercise || "5"} days`,
              },
            ].map((info, index) => (
              <div key={index}>
                <div className="flex items-center justify-between py-2">
                  <span className="text-sm text-muted-foreground">
                    {info.label}
                  </span>
                  <span className="text-right font-medium capitalize text-foreground">
                    {info.value}
                  </span>
                </div>
                {index < 3 && <div className="h-px bg-border" />}
              </div>
            ))}
          </div>
        </Card>

        {/* Edit Button */}
        <Button
          onClick={() => navigate("/profile/edit")}
          className="h-12 w-full rounded-xl"
        >
          <Edit className="mr-2 h-4 w-4" />
          Edit Information
        </Button>
      </div>
    </div>
  );
};

export default PersonalInformation;
